import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Link, LinkProps } from "@mui/material";

interface RouterLinkProps extends LinkProps {
  to: string;
}

export function RouterLink(props: RouterLinkProps) {
  return <Link component={ReactRouterLink} {...props} />;
}
